<template>
  <div class="content-wrapper">
    <div class="overlay" :class="{ 'overlayshow': modal.overlay }"></div>

    <!-- Initial Form -->
    <slot name="initial-form"></slot>

    <!-- Submitted Form Detail -->
    <slot name="submitted-form" v-bind="{ toggleCollapse, isCollapse, openModal, closeModal, modal }"></slot>

    <!-- Form Action -->
    <slot name="action-form" v-bind="{ toggleCollapse, isCollapse, openModal, closeModal, modal }">
      <div v-permissions="`Revision ${permissions},Approve ${permissions}`" v-if="detail?.status?.value === 'waiting_approval'" class="white-box mm15 p30 mb-3" style="min-height: auto;">
        <div class="popup-item p-0">
          <div class="row">
            <div class="col-sm-12">
              <div class="d-flex flex-row justify-content-between align-items-center">
                <div class="ft-16 font-bold">{{ approvalTitle }}</div>
              </div>
              <div class="popup-item wb">
                <div class="row mt-2">
                  <div v-permissions="`Revision ${permissions}`" class="col-sm-6">
                    <button @click="openModal('revision')" class="btn btn-border-orange w-100">Need Revision</button>
                  </div>
                  <div v-permissions="`Approve ${permissions}`" class="col-sm-6">
                    <button @click="openModal('approve')" class="btn btn-orange w-100">Approve</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Form Revision Modal -->
        <div class="popup-wrapper" :class="{ 'showing': modal.revision }">
          <div class="popup-card p25">
            <div class="d-flex justify-content-between align-items-center">
              <div class="font-bold">Need Revision</div>
              <button type="button" @click="closeModal('revision')" class="btn btn-for-close"><span
                  class="icon-ico-close"></span></button>
            </div>
            <div class="inner-land">
              <div class="popup-item">
                <div class="row gap-2">
                  <form ref="formRevision" @submit.prevent="onRevision" class="col-sm-12">
                    <FieldTextArea name="Reason" rules="required" v-model="revision.reason" />
                    <div class="row mt-2">
                      <div class="col-sm-6">
                        <button @click="closeModal('revision')" type="button" class="btn btn-orange w-100">Back</button>
                      </div>
                      <div class="col-sm-6">
                        <button type="submit" class="btn btn-border-orange w-100">Send</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Form Approve Modal (hook) -->
        <div class="popup-wrapper" :class="{ 'showing': modal.approve }">
          <div class="popup-card p25" style="max-width: 366px;">
            <div class="d-flex justify-content-between align-items-center">
              <div class="font-bold">Approve</div>
            </div>
            <div class="inner-land mt-2">
              <div class="popup-item p-0">
                <div>Are you sure to approve this request?</div>
                <div class="row mt-3">
                  <div class="col-sm-6">
                    <button @click="closeModal('approve')" type="button" class="btn btn-orange w-100">Back</button>
                  </div>
                  <div class="col-sm-6">
                    <button @click="() => {
                      modal.approve = false
                      modal.close = true
                    }" type="button" class="btn btn-border-orange w-100">Send</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Form Approve / Close Modal (hook) -->
        <div class="popup-wrapper" :class="{ 'showing': modal.close }">
          <div class="popup-card p25" style="max-width: 366px;">
            <div class="inner-land mt-2">
              <div class="popup-item p-0">
                <div>Do you want to continue this request for {{ nextStep }}</div>
                <div class="row mt-3">
                  <div class="col-sm-6">
                    <button @click="onClose" type="button" class="btn btn-border-orange w-100">No</button>
                  </div>
                  <div class="col-sm-6">
                    <button @click="onApprove" type="button" class="btn btn-border-orange w-100">Yes</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </slot>

    <!-- Rejection Detail -->
    <div v-if="detail && revisions.length && detail?.status?.value === 'revision'" class="white-box mm15 p30 mb-3" style="min-height: auto;">
      <div class="popup-item p-0">
        <div class="row">
          <div class="col-sm-12">
            <div class="d-flex flex-row  align-items-center gap-2">
              <div style="border-radius: 100%; width: 7px; height: 7px; background-color: #F4AF00;"></div>
              <div class="ft-12">Revision From - <strong>{{ revisionFromText ?? revisions[revisions.length - 1]?.created_by_detail?.role }}</strong></div>
            </div>
            <div class="p-3 my-3 rounded"
              style="border-top-left-radius: 0 !important; background-color: #E9EAF3; color: #292865;">
              {{ revisions[revisions.length - 1]?.revision }}
            </div>
            <slot name="cta-edit-form"></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import FieldTextArea from '@/components/field/TextArea.vue';

export default {
  name: "FNCDetailContent",
  props: ['approvalTitle', 'detail', 'nextStep', 'revisionFromText', 'permissions'],
  components: {
    FieldTextArea
  },
  data() {
    return {
      isCollapse: true,
      modal: {
        overlay: false,
        detail: false,
        revision: false,
        approve: false,
        close: false
      },

      // data
      revision: {
        reason: ''
      }
    }
  },
  methods: {
    closeModal(type) {
      this.modal[type] = false
      this.modal.overlay = false
    },
    openModal(type) {
      this.modal[type] = true
      this.modal.overlay = true
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse
    },
    async onRevision() {
      const valid = await this.$validator.validate()
      if (valid) {
        const callback = () => {
          this.closeModal('revision')
          this.revision.reason = ''
        }

        this.$emit('on-revision', {
          reason: this.revision.reason,
          callback: callback
        })
      }
    },
    async onClose() {
      const callback = () => {
        this.closeModal('close')
      }
      this.$emit('on-close', {
        callback: callback
      })
    },
    async onApprove() {
      const callback = () => {
        this.closeModal('close')
      }
      this.$emit('on-approve', {
        callback: callback
      })
    },
  },
  computed: {
    revisions() {
      if (this.detail?.revisions) return this.detail?.revisions
      if (this.detail?.revision) return this.detail?.revision
      return []
    }
  }
}
</script>
<style lang="css" scoped>
.card-content {
  padding: 0;
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.3s ease-out;
}

.card-content.show {
  /* margin-top: 15px; */
  max-height: 1000px;
  transition: max-height 0.5s ease-in;
}

.rotate {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
</style>
